import { List, NeoModel } from "@singularsystems/neo-core";
import { Views } from "@singularsystems/neo-react";
import SFTPBrokerDetailsLookup from "../Models/Lookups/SFTPBrokerDetailsLookup";
import { AppService, Types } from '../../../App/Services/AppService';
import UpdateSFTPDetailCommand from "../Models/Commands/UpdateSFTPBrokerDetailCommand";
import AddSFTPDetailCommand from "../Models/Commands/AddSFTPBrokerDetailCommand";
import SftpDetailsLookup from "../Models/Lookups/SftpDetailsLookup";

@NeoModel
export default class ManageBrokerSFTPDetailsComponentVM extends Views.ViewModelBase{

    constructor( 
        public serviceProviderApiCLient = AppService.get(Types.ApiClients.ServiceProviderApiClient),
        public generalApiClient = AppService.get(Types.ApiClients.GeneralApiClient),
        taskRunner = AppService.get(Types.Neo.TaskRunner))
    {
        super(taskRunner);
    }

    public async initialise() {
        await this.populateSFTPDetailsList();
    }
    public managedBrokerSFTPDetails = new SFTPBrokerDetailsLookup();
    public selectedSftpDetail = new SftpDetailsLookup;
    public sftpDetailsList = new List(SftpDetailsLookup);
   
    public async updateSFTPDetails(){
        await this.serviceProviderApiCLient.setSFTPBrokerDetails(new UpdateSFTPDetailCommand().mapFrom(this.managedBrokerSFTPDetails)!.toJSObject());
        this.managedBrokerSFTPDetails = new SFTPBrokerDetailsLookup();        
    }

    public async populateSFTPDetailsList()
    {
        var response = await this.taskRunner.waitFor(this.generalApiClient.getSftpDetailsList());
        this.sftpDetailsList.set(response.data);   
    }

    public setSftpDetails(){
        let detail = this.sftpDetailsList.find(x => x.sftpdetailId === this.selectedSftpDetail.sftpdetailId)!.toJSObject();
        this.managedBrokerSFTPDetails.sftpDetailId = detail.sftpdetailId;
        this.managedBrokerSFTPDetails.sftpSetting = detail.sftpSetting;
        this.selectedSftpDetail.set(detail);
    }

    public async addSFTPDetails() {
        if (this.managedBrokerSFTPDetails.staticServiceProviderFileGroupingId > 0) {
            this.managedBrokerSFTPDetails.staticServiceProviderSftpdetailsId = 0;
            await this.serviceProviderApiCLient.addSFTPBrokerDetails(new AddSFTPDetailCommand().mapFrom(this.managedBrokerSFTPDetails)!.toJSObject());            
        }
        this.managedBrokerSFTPDetails = new SFTPBrokerDetailsLookup();
    }
}